<template>
  <!-- 商品列表 -->
  <ul class="product-ul" :class="{'flash-sale': ['flash-sale', 'new-arrival'].includes(type) }">
    <li
      v-for="(item, idx) in previewProductList"
      :key="idx"
      class="product-li"
      :class="{
        'product-li-default': !type,
        'flash-sale-li' : type === 'flash-sale' ,
        'flash-sale-li new-arrival': type === 'new-arrival'
      }"
    >
      <KProductItem :source="item.source" :type="type" :productData="item" />
    </li>
  </ul>
</template>
<script setup lang="ts">
const props = defineProps<{
  productList: any,
  type?: any
}>()

const defaultList = new Array(4).fill({ listingId: 0, price: 0, minPrice: 0, maxPrice: 0, image: '', title: '' })
const previewProductList = ref<any[]>(!!props.type ? defaultList : [])

watchEffect(() => {
  if(props.productList?.length > 0) {
    previewProductList.value = props.productList
  }
})

</script>
<style lang='scss' scoped>
.product-ul {
  // margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 10px 0;
  .product-li {
    width: calc(100% / 2 - 5px);
    margin-bottom: 10px;
  }
  .product-li-default:nth-child(odd) {
    margin-right: 10px;
  }
  
  .product-li.flash-sale-li {
    width: 25%;
    padding: 0 16px;
    display: inline-block;
  }
  .product-li.new-arrival {
    width: 25%;
  }
}
.product-ul.flash-sale {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  flex-wrap: nowrap;
  display: block;
}
.product-ul::-webkit-scrollbar {
  display: none;
}
</style>